var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainInputField"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"label-input",class:`label-input--${_vm.type}`,domProps:{"innerHTML":_vm._s(_vm.value)}}),(_vm.errors)?_c('div',{staticClass:"helperError"},[_vm._v(_vm._s(_vm.errors[0]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }